import axios from 'axios';

export default {
    name: "adivare-favourite-btn-star",
    props: [
        'rentalId',
        'rentalShortId',
    ],
    computed: {
        isFavored: function () {
            return undefined !== this.userFavouriteIds &&
                null !== this.userFavouriteIds &&
                true === Array.isArray(this.userFavouriteIds) &&
                this.userFavouriteIds.includes(this.rentalId);
        },
        favouriteLink: function () {
            if (this.userId === undefined || this.userId === null) {
                return '/registreren/modal/favoriet/'+this.rentalShortId+'/';
            }
            if (this.isFavored) {
                return '/woning/'+this.rentalShortId+'/verwijder_favoriet';
            }
            return '/woning/'+this.rentalShortId+'/favoriet';
        },
        userId           () { return this.$store.state.userId; },
        userFavouriteIds () { return this.$store.state.userFavouriteIds; }
    },
    methods: {
        processLikeClicked() {
            this.$store.commit('toggleFavourite', { id: this.rentalId });
            axios
                .post(this.favouriteLink)
                .then((data) => {
                    if (data['status'] === 'fail') {
                        throw new Error('Failed to favourite');
                    }
                })
                .catch(() => {
                    this.$store.commit('toggleFavourite', { id: this.rentalId });
                    console.error('Failed to favourite');
                });
        }
    },
}
